import React, { useState, useEffect, useCallback } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../../store/ducks/userProfile';
import useStyles from './styles';

const WelcomeModal = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    product: { showWelcomeMessage },
    userProfile: { firstAccess },
  } = useSelector(state => state);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (firstAccess.show !== null) {
      setOpen(
        firstAccess.show && !!firstAccess?.htmlMessage && showWelcomeMessage,
      );
    } else {
      dispatch(Actions.getUserFirstAccess());
    }
  }, [dispatch, firstAccess, showWelcomeMessage]);

  const handleClose = useCallback(() => {
    setOpen(false);
    dispatch(
      Actions.saveFirstAccessLog({
        show: false,
      }),
    );
  }, [dispatch]);

  const createMarkup = useCallback(
    () => ({ __html: firstAccess?.htmlMessage }),
    [firstAccess?.htmlMessage],
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        className: classes.container,
      }}
    >
      <DialogContent dividers>
        {/* eslint-disable-next-line */}
        <div dangerouslySetInnerHTML={createMarkup()} />
      </DialogContent>
      <DialogActions>
        <Button
          className="welcome-modal-button"
          onClick={handleClose}
          color="primary"
        >
          OK, ENTENDI!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomeModal;
